module.exports = __webpack_public_path__ + "static/media/sureguard.734e377e.svg";